/**
 * SOLID Review
 * S — Strong. One concern: subscribe to the player's pushed credit balance and map it.
 * O — Strong. A second payment operation is one more method and one more document.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. Implements a one-method port; no consumer sees more than it needs.
 * D — Strong. Takes IPortGraphQLDomainClient — the narrow executor — never the Apollo singleton.
 */
/**
 * DDD Layer: Infrastructure — the Payment half of the client↔server seam.
 *
 * The executor arrives from THIS domain's socket on ComponentFrontendInfrastructure
 * (`graphQLPaymentDomainPort`), not as an imported client and not from the round socket, which is
 * where this operation used to travel. See IAdapterApolloPayment for what that cost.
 */
import { gql } from '@apollo/client';
import type { IAdapterApolloPayment, IEntityConsumedCredit } from '../../application/payment/ports/IAdapterApolloPayment';
import type { IPortGraphQLDomainClient } from '../contract/ports';

const CREDITS_UPDATED_SUB = gql`
  subscription ApolloPaymentAdapter_CreditsUpdated($playerId: ID!) {
    creditsUpdated(playerId: $playerId) { playerId newCredits }
  }
`;

export class ApolloPaymentAdapter implements IAdapterApolloPayment {
  constructor(private readonly client: IPortGraphQLDomainClient) {}

  subscribeToCreditsUpdated(playerId: string, onEvent: (ev: IEntityConsumedCredit) => void): () => void {
    const sub = this.client.subscribe<{ creditsUpdated: IEntityConsumedCredit }>({ query: CREDITS_UPDATED_SUB, variables: { playerId } }).subscribe({
      next: ({ data }) => {
        if (data?.creditsUpdated) onEvent(data.creditsUpdated);
      },
      error: (err: unknown) => console.warn('[ApolloPaymentAdapter] creditsUpdated subscription error:', err),
    });
    return () => sub.unsubscribe();
  }
}
